import { TICKET_STATUS_DISPLAY_MAP } from "./constants";
import type { TicketStatus, TicketFilters } from "#graphql/supergraphTypes";

export { TICKET_STATUS_DISPLAY_MAP };

export const hasWorkTypeFilterInFilters = (filters: TicketFilters | null): boolean => {
  return filters?.additionalFilters?.some((filter) => filter.field === "issuetype") ?? false;
};

export const getWorkTypeFromFilters = (filters: TicketFilters | null): string | null => {
  const workTypeFilter = filters?.additionalFilters?.find(
    (filter) => filter.field === "issuetype",
  );
  return workTypeFilter?.value ?? null;
};

export const formatTicketStatus = (status: TicketStatus): string => {
  return TICKET_STATUS_DISPLAY_MAP[status] ?? status;
};

export const formatCustomerName = (customerString: string): string => {
  const clientName = customerString.replace(/_\d+$/, "").replace(/_/g, " ");
  return clientName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const getOriginFromUrl = (url: string) => {
  try {
    return new URL(url).origin;
  } catch {
    return "";
  }
};
